/** The knowledge cap in words (the founder, 2026-10-13; DECISIONS "2026-10-13 — The knowledge cap in words per project"): a project's
 *  knowledge is measured in words, the unit a person can compare with the text they wrote; chunks stay the retrieval's own detail. Pure:
 *  the one word rule, the pages a number of words is "about", and the sentences the meter, the plan cards and every refusal share. */

/** "about N pages": a page is 500 words (the founder's table) */
export const WORDS_PER_PAGE = 500;

/** a Chinese character, a kana (scripts Han, Hiragana, Katakana) with its combining marks: one word each, since those languages write no spaces */
const SPACELESS = String.raw`[\p{sc=Han}\p{sc=Hiragana}\p{sc=Katakana}]`;
/** one word: a spaceless character, or a run of letters, combining marks and digits in any other script; everything else separates */
const WORD = new RegExp(`${SPACELESS}\\p{M}*|(?:(?!${SPACELESS})[\\p{L}\\p{M}\\p{N}])+`, "gu");

/** The one word rule: a page's Markdown or text (a repository's code file too) counted before it is cut. Hyphens, apostrophes,
 *  underscores, dots, Markdown's marks and emoji separate ("e-mail" and "3.5" are two words); Korean counts by its spaced runs. */
export function countWords(text: string): number {
  let n = 0;
  for (const _ of text.matchAll(WORD)) n++;
  return n;
}

/** the pages a number of words is about, rounded */
export const aboutPages = (words: number): number => Math.round(words / WORDS_PER_PAGE);
/** a number as the texts write it: en-US digits ("250,000") */
const digits = (n: number): string => n.toLocaleString("en-US");

/** the plan cards' line: "250,000 words per project · about 500 pages" */
export const knowledgeAllowance = (words: number): string => `${digits(words)} words per project · about ${digits(aboutPages(words))} pages`;

/** a plan named with its words per project, for a refusal */
export type KnowledgePlan = { name: string; words: number };
/** Every refusal's sentence (a switch, a publish, an embed run, a source's sync): the plan with its cap and pages, then the cheapest plan
 *  on sale with room, or none. "Free allows 50,000 words per project (about 100 pages); Starter allows 250,000 (about 500 pages)." */
export function knowledgeRefusal(plan: KnowledgePlan, wayUp: KnowledgePlan | null): string {
  const mine = `${plan.name} allows ${digits(plan.words)} words per project (about ${digits(aboutPages(plan.words))} pages)`;
  return wayUp ? `${mine}; ${wayUp.name} allows ${digits(wayUp.words)} (about ${digits(aboutPages(wayUp.words))} pages).` : `${mine}; no plan on sale allows more.`;
}
/** a sync that stored some pages and refused the rest: "12 pages left out: Free allows …" */
export const pagesLeftOut = (refused: number, refusal: string): string => `${digits(refused)} ${refused === 1 ? "page" : "pages"} left out: ${refusal}`;
